import { boundApiRequest } from '@/restapi/restapi.base.js';


const doRequest = boundApiRequest('/api/audit/');


export function analyticsExport(reqt) {
    doRequest('export', reqt, { messages: false });
}
